var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsRequest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40003800_891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40003800_891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H22V22H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40003800_891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.1992C10.5 18.7708 8.41532 20.8555 5.84375 20.8555C3.27218 20.8555 1.1875 18.7708 1.1875 16.1992C1.1875 13.6277 3.27218 11.543 5.84375 11.543C8.41532 11.543 10.5 13.6277 10.5 16.1992ZM11.5 16.1992C11.5 13.0754 8.9676 10.543 5.84375 10.543C2.7199 10.543 0.1875 13.0754 0.1875 16.1992C0.1875 19.3231 2.7199 21.8555 5.84375 21.8555C8.9676 21.8555 11.5 19.3231 11.5 16.1992Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34375 16.7314V16.8438C5.34375 17.1199 5.56761 17.3438 5.84375 17.3438C6.11989 17.3437 6.34375 17.1199 6.34375 16.8438V16.7314C6.34375 16.5546 6.44633 16.3902 6.61328 16.3105C7.30532 15.9804 7.75226 15.2166 7.60449 14.375C7.47707 13.6495 6.88963 13.062 6.16406 12.9346C5.03823 12.7369 4.05469 13.6012 4.05469 14.6953C4.05469 14.9715 4.27855 15.1953 4.55469 15.1953C4.83083 15.1953 5.05469 14.9715 5.05469 14.6953C5.05469 14.2125 5.48741 13.8305 5.99121 13.9189C6.30221 13.9736 6.56549 14.2369 6.62012 14.5479C6.6865 14.9259 6.48914 15.262 6.18262 15.4082C5.67523 15.6503 5.34375 16.161 5.34375 16.7314Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48828 18.9922C6.48828 19.3481 6.1997 19.6367 5.84375 19.6367C5.4878 19.6367 5.19922 19.3481 5.19922 18.9922C5.19922 18.6362 5.4878 18.3477 5.84375 18.3477C6.1997 18.3477 6.48828 18.6362 6.48828 18.9922Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 20.0664C20.8125 20.5022 20.4592 20.8555 20.0234 20.8555H5.84375C5.56761 20.8555 5.34375 21.0793 5.34375 21.3555C5.34375 21.6316 5.56761 21.8555 5.84375 21.8555H20.0234C21.0115 21.8555 21.8125 21.0545 21.8125 20.0664V4.94141C21.8125 4.80885 21.7597 4.68163 21.666 4.58789L17.3691 0.291016C17.2754 0.197302 17.1482 0.144531 17.0156 0.144531H7.13281C6.14476 0.144531 5.34375 0.945545 5.34375 1.93359V11.043C5.34375 11.3191 5.56761 11.543 5.84375 11.543C6.11989 11.543 6.34375 11.3191 6.34375 11.043V1.93359C6.34375 1.49783 6.69705 1.14453 7.13281 1.14453H16.8086L20.8125 5.14844V20.0664Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 5.44141C21.5147 5.44141 21.697 5.31961 21.7744 5.13281C21.8518 4.94598 21.809 4.73089 21.666 4.58789L17.3691 0.291016C17.2261 0.148017 17.0111 0.105227 16.8242 0.182617C16.6374 0.260023 16.5156 0.442323 16.5156 0.644531V4.94141C16.5156 5.21755 16.7395 5.44141 17.0156 5.44141H21.3125ZM17.5156 1.85156L20.1055 4.44141H17.5156V1.85156Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3047 12.832C18.5808 12.832 18.8047 12.6082 18.8047 12.332C18.8047 12.0559 18.5808 11.832 18.3047 11.832H9.25391C8.97776 11.832 8.75391 12.0559 8.75391 12.332C8.75391 12.6082 8.97776 12.832 9.25391 12.832H18.3047Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3047 8.96484L18.4053 8.95508C18.6332 8.90855 18.8047 8.70656 18.8047 8.46484C18.8047 8.22313 18.6332 8.02114 18.4053 7.97461L18.3047 7.96484H8.85156C8.57542 7.96484 8.35156 8.1887 8.35156 8.46484C8.35156 8.74099 8.57542 8.96484 8.85156 8.96484H18.3047Z",
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3047 16.6992L18.4053 16.6895C18.6332 16.6429 18.8047 16.4409 18.8047 16.1992C18.8047 15.9575 18.6332 15.7555 18.4053 15.709L18.3047 15.6992H11C10.7239 15.6992 10.5 15.9231 10.5 16.1992C10.5 16.4754 10.7239 16.6992 11 16.6992H18.3047Z",
    fill: "#0A0F0D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40003800_891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsRequest);
export default __webpack_public_path__ + "static/media/terms-request.1220a96efc6d65eb70ed99cfb34b27e5.svg";
export { ForwardRef as ReactComponent };